import {Scheduler} from '@/constants/actionType';

export function setShowScheduleRunModal(value) {
  return {
    type: Scheduler.SET_SHOW_SCHEDULE_RUN_MODAL,
    value,
  };
}

export function setScheduleRun(value) {
  return {
    type: Scheduler.SET_SCHEDULE_RUN,
    value,
  };
}

export function setScheduleWillRun(value) {
  return {
    type: Scheduler.SET_SCHEDULE_REMINDER,
    value,
  };
}

export function setScheduleType(value) {
  return {
    type: Scheduler.SET_SCHEDULE_TYPE,
    value,
  };
}

export function setScheduleId(value) {
  return {
    type: Scheduler.SET_SCHEDULE_ID,
    value,
  };
}

export function setDeltaTime(value) {
  return {
    type: Scheduler.SET_DELTA_TIME,
    value,
  };
}

export function setStartTime(value) {
  return {
    type: Scheduler.SET_START_TIME,
    value,
  };
}

export function resetScheduler() {
  return {
    type: Scheduler.RESET,
  };
}
